/* Build-your-set panel on single organic cotton product pages (snippets/singla-pdp-bundle.liquid).
   Same pricing and behaviour as the homepage cart builder: the page's product (in the size picked
   in the size bar) is the base piece; add-on cards show "+$X" after the bundle discount.
   Discounts are applied at checkout by the store's automatic Organic Cotton discounts.
   Lace pages (data-no-discount) have one colourway and no bundle discount. */
(function () {
  var SIZE_ALIASES = { xs: 'extrasmall', s: 'small', m: 'medium', l: 'large', xl: 'extralarge' };
  var SIZE_LABELS = { extrasmall: 'XS', small: 'S', medium: 'M', large: 'L', extralarge: 'XL' };
  var COLOR_LABELS = { 'Cloud': 'White - Cloud', 'All Aboard!': 'Navy - All Aboard!', 'Naked Truth': 'Nude - Naked Truth', 'Onyx': 'Black - Onyx', 'Navy': 'Navy - All Aboard!' };
  var FREE_SHIPPING_CENTS = 7500;
  var PREREQ = { base3: 'base2', match2: 'match1' };

  function normalizeSize(size) {
    var key = String(size).toLowerCase().replace(/[^a-z]/g, '');
    return SIZE_ALIASES[key] || key;
  }

  function formatMoney(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  // 2 items 5%, 3 items 10%, 4+ items 15%.
  function discountFor(count) {
    return count >= 4 ? 15 : count === 3 ? 10 : count === 2 ? 5 : 0;
  }

  function copyState(s) {
    return { match1: s.match1, base2: s.base2, base3: s.base3, match2: s.match2 };
  }

  // Ticking a later piece ticks the earlier one too (a 3rd needs a 2nd); unticking clears what depends on it.
  function withAddon(state, name, on) {
    var next = copyState(state);
    next[name] = on;
    if (on && name === 'base3') next.base2 = true;
    if (on && name === 'match2') next.match1 = true;
    if (!on && name === 'base2') next.base3 = false;
    if (!on && name === 'match1') next.match2 = false;
    return next;
  }

  function counts(state) {
    return {
      base: 1 + (state.base2 ? 1 : 0) + (state.base3 ? 1 : 0),
      match: (state.match1 ? 1 : 0) + (state.match2 ? 1 : 0)
    };
  }

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-bundle-data]').textContent);
    var colorIndex = parseInt(root.dataset.baseIndex, 10) || 0;
    var bundlesEl = root.querySelector('[data-bundles]');
    var addonBtns = bundlesEl.querySelectorAll('[data-addon]');
    var picksEl = bundlesEl.querySelector('[data-picks]');
    var atcBtn = root.querySelector('[data-bundle-atc]');
    var msgEl = root.querySelector('[data-bundle-msg]');
    var BASE_LABEL = bundlesEl.dataset.baseLabel;
    var MATCH_LABEL = bundlesEl.dataset.matchLabel;
    var noDiscount = root.hasAttribute('data-no-discount');
    var bundleDiscount = function (count) { return noDiscount ? 0 : discountFor(count); };
    var variantEl = document.querySelector('variant-radios[data-section="' + root.dataset.section + '"], variant-selects[data-section="' + root.dataset.section + '"]');
    var addons = { match1: false, base2: false, base3: false, match2: false };
    var slots = [];
    var sizeKey = '';
    var busy = false;

    function selectedSize() {
      if (!variantEl) return null;
      var radio = variantEl.querySelector('input[type="radio"]:checked');
      if (radio) return radio.value;
      var select = variantEl.querySelector('select');
      return select ? select.value : null;
    }

    function baseVariant() {
      var size = selectedSize();
      if (!size) return null;
      return data.colors[colorIndex].variants.find(function (v) { return normalizeSize(v.size) === normalizeSize(size); }) || null;
    }

    function priceFor(state) {
      var color = data.colors[colorIndex];
      var c = counts(state);
      var matchPrice = color.match ? color.match.price_cents : 0;
      return (c.base * color.price_cents + c.match * matchPrice) * (1 - bundleDiscount(c.base + c.match) / 100);
    }

    // "+$X" is what that one piece adds (after the bigger bundle discount), with the piece before it already in.
    function renderAddons() {
      var color = data.colors[colorIndex];
      addonBtns.forEach(function (btn) {
        var name = btn.dataset.addon;
        var on = addons[name];
        var base = copyState(addons);
        base[name] = false;
        if (name === 'base2') base.base3 = false;
        if (name === 'match1') base.match2 = false;
        if (PREREQ[name]) base[PREREQ[name]] = true;
        var withPiece = copyState(base);
        withPiece[name] = true;
        btn.querySelector('[data-addon-price]').textContent = '+' + formatMoney(priceFor(withPiece) - priceFor(base));
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('scb__addon--on', on);
        var product = name.indexOf('match') === 0 ? color.match : color;
        var img = btn.querySelector('[data-addon-img]');
        if (product && product.image && img.getAttribute('src') !== product.image) {
          img.src = product.image;
          img.alt = product.title;
        }
      });
    }

    function slotProduct(slot) {
      var color = data.colors[slot.color];
      return slot.kind === 'match' ? color.match : color;
    }

    function slotVariant(slot) {
      var product = slotProduct(slot);
      if (!product) return null;
      return product.variants.find(function (v) { return normalizeSize(v.size) === slot.size; }) || null;
    }

    function slotName(slot) {
      var same = slots.filter(function (s) { return s.kind === slot.kind; });
      var label = slot.kind === 'match' ? MATCH_LABEL : BASE_LABEL;
      return same.length > 1 ? label + ' ' + (same.indexOf(slot) + 1) : label;
    }

    // Keeps colours/sizes already chosen; new pieces start on this product's colour and the size picked.
    function syncSlots(reset) {
      var variant = baseVariant();
      if (!variant) return;
      var size = normalizeSize(variant.size);
      var c = counts(addons);
      var bases = reset ? [] : slots.filter(function (s) { return s.kind === 'base'; });
      var matches = reset ? [] : slots.filter(function (s) { return s.kind === 'match'; });
      bases = bases.slice(0, c.base);
      matches = matches.slice(0, c.match);
      while (bases.length < c.base) bases.push({ kind: 'base', color: colorIndex, size: size });
      while (matches.length < c.match) matches.push({ kind: 'match', color: colorIndex, size: size });
      slots = bases.concat(matches);
      picksEl.hidden = slots.length <= 1;
      if (slots.length > 1) buildRows();
    }

    function sizeOptions(slot) {
      return slotProduct(slot).variants.map(function (v) {
        var key = normalizeSize(v.size);
        var label = (SIZE_LABELS[key] || v.size) + (v.available ? '' : ' (sold out)');
        return '<option value="' + key + '"' + (key === slot.size ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + label + '</option>';
      }).join('');
    }

    function buildRows() {
      var rows = picksEl.querySelector('[data-pick-rows]');
      rows.innerHTML = '';
      slots.forEach(function (slot) {
        var row = document.createElement('div');
        row.className = 'scb__pick';
        var colorOpts = data.colors.map(function (c, i) {
          var product = slot.kind === 'match' ? c.match : c;
          if (!product) return '';
          return '<option value="' + i + '"' + (i === slot.color ? ' selected' : '') + '>' + (COLOR_LABELS[c.name] || c.name) + '</option>';
        }).join('');
        // One colourway (lace): no colour choice, just the size.
        var colorHidden = data.colors.length === 1 ? ' hidden style="display:none"' : '';
        row.innerHTML =
          '<span class="scb__pick-name">' + slotName(slot) + '</span>' +
          '<select class="scb__pick-select" data-pick-color aria-label="' + slotName(slot) + ' colour"' + colorHidden + '>' + colorOpts + '</select>' +
          '<select class="scb__pick-select" data-pick-size aria-label="' + slotName(slot) + ' size">' + sizeOptions(slot) + '</select>';
        var colorSel = row.querySelector('[data-pick-color]');
        var sizeSel = row.querySelector('[data-pick-size]');
        colorSel.addEventListener('change', function () {
          slot.color = parseInt(colorSel.value, 10);
          sizeSel.innerHTML = sizeOptions(slot);
          sizeSel.value = slot.size;
          update();
        });
        sizeSel.addEventListener('change', function () {
          slot.size = sizeSel.value;
          update();
        });
        rows.appendChild(row);
      });
    }

    function bundleTotal() {
      var subtotal = 0;
      slots.forEach(function (slot) {
        var product = slotProduct(slot);
        subtotal += product ? product.price_cents : 0;
      });
      return subtotal * (1 - bundleDiscount(slots.length) / 100);
    }

    function validatePicks() {
      if (slots.length <= 1) return true;
      var tally = {};
      var error = '';
      slots.forEach(function (slot) {
        var v = slotVariant(slot);
        if (!v || !v.available) {
          if (!error) error = slotName(slot) + ': ' + data.colors[slot.color].name + ' is sold out in that size.';
          return;
        }
        tally[v.id] = (tally[v.id] || 0) + 1;
        if (tally[v.id] > v.max && !error) {
          error = 'Only ' + v.max + ' left in ' + data.colors[slot.color].name + ' ' + (SIZE_LABELS[slot.size] || v.size) + ' ' +
            (slot.kind === 'match' ? MATCH_LABEL : BASE_LABEL).toLowerCase() + ' — pick another colour or size for ' + slotName(slot) + '.';
        }
      });
      picksEl.querySelector('[data-picks-error]').textContent = error;
      return !error;
    }

    function renderPreview() {
      var preview = bundlesEl.querySelector('[data-pick-preview]');
      if (slots.length <= 1) { preview.innerHTML = ''; return; }
      var tiles = [];
      var byKey = {};
      slots.forEach(function (slot) {
        var product = slotProduct(slot);
        var v = slotVariant(slot);
        if (!product || !v) return;
        var key = slot.kind + '|' + slot.color + '|' + slot.size;
        if (!byKey[key]) {
          byKey[key] = { image: product.image, title: product.title, size: v.size, qty: 0 };
          tiles.push(byKey[key]);
        }
        byKey[key].qty += 1;
      });
      preview.innerHTML = tiles.slice(0, 4).map(function (t) {
        return '<figure class="scb__pick-tile">' +
          '<img src="' + t.image + '" alt="' + String(t.title).replace(/"/g, '&quot;') + ', ' + t.size + '" loading="lazy">' +
          '<figcaption><em>x' + t.qty + ' - <span class="scb__tile-size-long">' + t.size + '</span>' +
          '<span class="scb__tile-size-short">' + (SIZE_LABELS[normalizeSize(t.size)] || t.size) + '</span></em></figcaption>' +
          '</figure>';
      }).join('');
    }

    function renderSummary() {
      var total = bundleTotal();
      var discount = bundleDiscount(slots.length);
      var free = total >= FREE_SHIPPING_CENTS;
      bundlesEl.querySelector('[data-total-amount]').textContent = formatMoney(total);
      bundlesEl.querySelector('[data-total-note]').textContent = discount ? discount + '% off, applied at checkout' : '';
      bundlesEl.querySelector('[data-ship-fill]').style.width = Math.min(100, (total / FREE_SHIPPING_CENTS) * 100) + '%';
      bundlesEl.querySelector('[data-ship-msg]').innerHTML = free
        ? '<strong>Free shipping</strong> in Canada'
        : 'Add ' + formatMoney(FREE_SHIPPING_CENTS - total) + ' more for <strong>free shipping</strong> in Canada';
      renderPreview();
    }

    function setButtonVisible(visible) {
      atcBtn.hidden = !visible;
      atcBtn.style.display = visible ? '' : 'none';
    }

    // The bundle button only shows once an add-on is ticked; the page's own Add to Cart covers a single item.
    function update() {
      var ok = validatePicks();
      renderSummary();
      if (busy) return;
      var count = slots.length;
      setButtonVisible(count > 1);
      atcBtn.disabled = !ok;
      atcBtn.textContent = 'Add bundle to cart (' + count + ' items' + (bundleTotal() >= FREE_SHIPPING_CENTS ? ' · Free shipping' : '') + ')';
    }

    function refresh() {
      var variant = baseVariant();
      if (!variant || !variant.available) {
        bundlesEl.hidden = true;
        setButtonVisible(false);
        return;
      }
      bundlesEl.hidden = false;
      var key = normalizeSize(variant.size);
      if (key !== sizeKey) {
        sizeKey = key;
        syncSlots(true);
      }
      renderAddons();
      update();
    }

    addonBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        addons = withAddon(addons, btn.dataset.addon, !addons[btn.dataset.addon]);
        syncSlots(false);
        renderAddons();
        update();
      });
    });

    if (variantEl) {
      variantEl.addEventListener('change', function () { setTimeout(refresh, 0); });
    }

    atcBtn.addEventListener('click', function () {
      if (slots.length <= 1 || !validatePicks()) return;
      var byId = {};
      var order = [];
      slots.forEach(function (slot) {
        var v = slotVariant(slot);
        if (!byId[v.id]) { byId[v.id] = 0; order.push(v.id); }
        byId[v.id] += 1;
      });
      var payload = { items: order.map(function (id) { return { id: id, quantity: byId[id] }; }) };
      // Same "added to cart" popup as the rest of the store.
      var cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        cartNotification.setActiveElement(atcBtn);
        payload.sections = cartNotification.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      busy = true;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      msgEl.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Error'); });
          return res.json();
        })
        .then(function (res) {
          var item = res.items ? { key: res.items[0].key, items: res.items, sections: res.sections } : res;
          if (cartNotification && item.sections) cartNotification.renderContents(item);
          atcBtn.textContent = 'Added!';
          setTimeout(function () { busy = false; update(); }, 2200);
        })
        .catch(function (err) {
          msgEl.textContent = err.message;
          msgEl.className = 'scb__msg scb__msg--error';
          busy = false;
          update();
        });
    });

    refresh();
  }

  function start() {
    document.querySelectorAll('[data-pdp-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
